import { render, staticRenderFns } from "./EventGuests.vue?vue&type=template&id=16cc4049&scoped=true"
import script from "./EventGuests.vue?vue&type=script&lang=ts"
export * from "./EventGuests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc4049",
  null
  
)

export default component.exports